<div class="p-4 sm:p-6 font-display">
  <div class="flex items-center justify-between w-full mb-4">
    <h2 class="text-lg sm:text-xl font-semibold text-[#1E1E1E]">
      Payment Method
    </h2>
    <button (click)="closeDialog()" class="rounded-full p-1">
      <i class="fa-solid fa-xmark text-lg text-gray-500 hover:text-gray-700"></i>
    </button>
  </div>

  @if (!doneChoose) {
  <p class="text-[#767676] mb-4 text-sm">
    Please Select your payment method to Disburse this invoice
  </p>

  <button
    (click)="selectedOption = 'Cash'"
    class="w-full p-3 text-sm text-[#5C5C5C] border border-[#BABABA] rounded-lg text-left hover:bg-gray-100 flex items-center justify-between"
  >
    <span>Cash</span>
    @if (selectedOption == 'Cash') {
    <i class="fa-solid fa-circle-check text-green-600"></i>
    }
  </button>

  <button
    (click)="selectedOption = 'Bank Transfer'"
    class="w-full p-3 text-sm text-[#5C5C5C] border border-[#BABABA] rounded-lg mt-2 text-left hover:bg-gray-100 flex items-center justify-between"
  >
    <span>Bank Transfer</span>
    @if (selectedOption == 'Bank Transfer') {
    <i class="fa-solid fa-circle-check text-green-600"></i>
    }
  </button>

  <div class="flex flex-col sm:flex-row w-full justify-end items-center gap-2 mt-4">
    <button
      (click)="submit()"
      [disabled]="!this.selectedOption"
      class="text-white py-2 px-6 rounded-lg focus:outline-none w-full sm:w-auto"
      [ngClass]="{
        'bg-[#85E2B1] cursor-pointer': this.selectedOption,
        'bg-[#8C8C8C]': !this.selectedOption
      }"
    >
      Submit
    </button>
    <button
      (click)="cancel()"
      class="bg-[#8C8C8C] text-white py-2 px-6 rounded-lg focus:outline-none w-full sm:w-auto"
    >
      Cancel
    </button>
  </div>
  } @else {
  <p class="text-[#767676] mb-4 text-sm">Here are the bank account details.</p>

  <div class="p-4 border border-[#BABABA] rounded-lg flex flex-col">
    <div class="flex w-full items-center justify-between">
      <span class="text-sm">Number:</span>
      <span class="text-sm">{{ data.bankAccount?.number ?? '-' }}</span>
    </div>
    <div class="flex w-full items-center justify-between mt-2">
      <span class="text-sm">Name:</span>
      <span class="text-sm">{{ data.bankAccount?.name ?? '-'}}</span>
    </div>
    <div class="w-full flex items-end justify-end mt-2">
      <span class="font-semibold">{{ data.bankAccount?.bank ?? '-'}}</span>
    </div>
  </div>

  <div class="flex flex-col sm:flex-row w-full justify-end items-center gap-2 mt-4">
    <button
      (click)="closeDialog()"
      class="bg-[#85E2B1] cursor-pointer text-white py-2 px-6 rounded-lg focus:outline-none w-full sm:w-auto"
    >
      Done
    </button>
    <button
      (click)="cancel()"
      class="bg-[#8C8C8C] text-white py-2 px-6 rounded-lg focus:outline-none w-full sm:w-auto"
    >
      Cancel
    </button>
  </div>
  }
</div>
